<template>
  <div class="verifyAccount">
    <div class="header_box">
      <a href="/user/logout.do">
        <img src="@/assets/logo.svg" alt="">
      </a>
    </div>
    <div class="content">
      <div class="mySteps">
      <span><i v-if="active-0<=1" :class="{current:active==1}">1</i><i  v-else class="el-icon-check success"></i>验证身份</span>
      <div class="line"></div>
      <span><i v-if="active-0<=2" :class="{current:active==2}">2</i><i  v-else class="el-icon-check success"></i>重置密码</span>
      <div class="line"></div>
      <span><i v-if="active-0<=3" :class="{current:active==3}">3</i><i  v-else class="el-icon-check success"></i>完成</span>
    </div>
      <div class="verify_box" v-if="active==1">
        <el-form ref="form" :model="form" label-width="108px">
          <el-form-item label="您的手机号：">
            <el-input v-model="form.phone" type="text" maxlength="11" @input="lenSlice"></el-input>
            <a class="border_box" href="javascript:;" @click="sendCodeFun">{{msg}}</a>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
          <a href="javascript:;" class="change-btn" @click="nextBtn">下一步</a>
        </el-form>
      </div>

      <div class="change_box" v-if="active==2">
        <el-form label-width="108px">
          <el-form-item label="新密码：">
            <el-input v-model="password" type="password"></el-input>
            <div class="strength">
              <span :class="{current:strength==1}">弱</span><span :class="{current:strength==2}">中</span><span :class="{current:strength>=3}">强</span>
            </div>
          </el-form-item>
          <el-form-item label="再次输入：">
            <el-input v-model="password2" type="password"></el-input>
          </el-form-item>
          <a href="javascript:;" class="change-btn" @click="changePwd">下一步</a>
        </el-form>
      </div>

      <div class="success_box" v-if="active==3">
        <p><i class="el-icon-check success"></i>恭喜您。密码成功重置！您可以使用新密码登录云平台</p>
        <a href="/user/logout.do" target="_top" class="change-btn" >立即登录</a>
      </div>
    </div>
  </div>
</template>
<script>
import { sendMsg,updataValidate,updataPasswordByPhone } from '@/api/common_api'
export default {
  data(){
    return {
      active:1,
      form:{
        phone:'',
        code:''
      },
      timer:null,
      msg:'免费获取验证码',
      time:60,
      password:'',
      password2:'',
      sendCode:true
    }
  },
  computed:{
    strength(){
      let isDigit = /^.*[0-9]+.*/,isLowerCase = /^.*[a-z]+.*/,isUpperCase = /^.*[A-Z]+.*/,regEx = /^.*[^a-zA-Z0-9]+.*/;
      let num=0
      if(isDigit.test(this.password)){
        num++
      }
      if(isLowerCase.test(this.password)){
        num++
      }
      if(isUpperCase.test(this.password)){
        num++
      }
      if(regEx.test(this.password)){
        num++
      }
      return num
    },
  },
  methods:{
    //发送验证码验证
    nextBtn(){
      let form = this.form
      if(!form.phone.length){
        this.$message.error('请输入手机号码');
        return false
      }
      if(!this.sendCode){
        this.$message.error('请先发送验证码')
        return false
      }
      if(!form.code.length){
        this.$message.error('请输入验证码');
        return false
      }
      form.use = 4
      updataValidate(form).then(res=>{
        if(res.s==1){
          this.active=2
        }else{
          this.$message.error(res.d);
        }
      })
    },
    //修改密码
    changePwd(){
      if(!this.password.length || !this.password2.length){
        this.$message.error('请输入密码');
        return false
      }
      if(this.password.length != this.password2.length){
        this.$message.error('两次密码输入的不一致');
        return false
      }
      updataPasswordByPhone({password:this.password,phone:this.form.phone}).then(res=>{
        if(res.s==1){
          this.active =3
        }else{
          this.$message.error(res.d);
        }
      })
    },
    //获取验证码
    sendCodeFun(){
      let phone = this.form.phone
      if(this.msg!='免费获取验证码'){
        return false
      }
      if(!phone.length){
        this.$message.error('请先输入手机号码');
        return false
      }
      sendMsg({phone:phone,use:4}).then(res=>{
        if(res.s==1){
          this.sendCode = true
          this.creatInter()
        }else{
          this.$message.error(res.d);
        }
      })
    },
    creatInter(){
      clearInterval(this.timer)
      this.time = 60
      this.timer = setInterval(()=>{
        this.time--
        this.msg = this.time+'秒后重试'
        if(this.time==0){
          clearInterval(this.timer)
          this.msg = '免费获取验证码'
        }
      },1000)
    },
    lenSlice(){
      let phone = this.form.phone
      phone = phone.replace(/[^\d]/g, '')
      if(phone.length>=11){
        phone = phone.slice(0,11)
      }
      this.form.phone = phone
    }
  }
}
</script>
<style lang="less">
.verifyAccount{
  .header_box{
    height: 88Px;
    background: #fff;
    line-height: 88Px;
    img{
      margin-left: 30Px;
      vertical-align: middle;
    }
  }
  .content{
    min-width: 1200Px;
    max-width: 1720Px;
    background: #fff;
    padding-bottom: 40px;
    margin: 40Px auto;
    padding-top: 48Px;
    text-align: center;
    .mySteps{
      font-size: 14Px;
      color: #444;
      margin: 0 auto;
      display: inline-block;
      span{
        margin: 0 10Px;
        i{
          display: inline-block;
          width: 32Px;
          height: 32Px;
          border-radius: 50%;
          background: #C6C6C6;
          vertical-align: middle;
          margin-right: 10Px;
          color: #fff;
          line-height: 32Px;
          text-align: center;
          font-size: 16Px;
          &.success{
            background: #1890FF;
          }
          &.current{
            background: #1890FF;
          }
        }
      }
      .line{
        width: 160Px;
        border-bottom: 1px dashed #979797;
        display: inline-block;
        vertical-align: middle;
      }
    }
    .el-form-item{
      margin-bottom: 40Px;
    }
    .el-form-item__label{
      color: #000;
      font-size: 16Px;
      line-height: 32Px;
    }
    .verify_box,.change_box{
      width: 438Px;
      margin:  60Px auto;
      .el-form-item__content{
        text-align: left;
        .el-input{
          width: 204Px;
          .el-input__inner{
            height: 32Px;
            line-height: 32Px;
          }
        }
        .border_box{
          width: 114Px;
          height: 32Px;
          box-sizing: border-box;
          border: 1px solid #1890FF;
          box-shadow: 0px 3Px 3Px 0px rgba(165, 200, 255, 0.53);
          display: inline-block;
          line-height: 30Px;
          color: #1890FF;
          font-size: 13Px;
          vertical-align: top;
          text-align: center;
          margin-left: 12Px;
        }
      }
      .change-btn{
        margin-top: 16Px;
      }
    }
    .change_box{
      width: 312Px;
      .el-form-item{
        margin-bottom: 25Px;
      }
    }
    .strength{
      display: flex;
      margin-top: 10Px;
      span{
        width: 68Px;
        height: 23PX;
        background: #A7D1FB;
        margin-right: 1Px;
        color: 14Px;
        color: #fff;
        text-align: center;
        :last-child{
          margin-right: 0;
        }
        &.current{
          background: #3499FD;
        }
      }
    }

    .success_box{
      font-size: 16Px;
      color: #444444;
      width: 910Px;
      height: 158Px;
      border: 1px solid #1890FF;
      box-shadow: 0px 3Px 3px 0px rgba(165, 200, 255, 0.53);
      margin: 40Px auto;
      p{
        margin: 32Px 0;
      }
      .el-icon-check{
        background: #1890FF;
        border-radius: 50%;
        color: #fff;
        font-size: 12Px;
        padding: 2Px;
        vertical-align: middle;
        margin-top: -2Px;
        margin-right: 7Px;
      }

    }
  }

  /deep/ input::-webkit-outer-spin-button,
   /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
   /deep/ input[type='number'] {
      -moz-appearance: textfield !important;
      -o-appearance: textfield !important;
    }
}
</style>